import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  billing_postal_code: string;
  root_account: any;
  status: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  private apiUrl = environment.apiURL+'accounts'; // URL del API
  private cache$: Observable<any> | null = null;

  constructor(private http: HttpClient) {}

  getData(): Observable<any> {
    if (!this.cache$) {
      this.cache$ = this.http.get(this.apiUrl).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.cache$;
  }

  addData(item: any): Observable<any> {
    this.cache$ = null; // Invalidar cache al agregar
    return this.http.post(this.apiUrl + '/new', item);
  }
}
